export default "\n<!-- <app-menu></app-menu> -->\n<router-outlet></router-outlet>\n\n"